import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BudgetCategoryService } from '../../../../services/budget-category.service';
import { LoadingService } from '../../../../services/loading.service';
import { ProjectService } from '../../../../services/project.service';
import { ToastService } from '../../../../services/toast.service';
import { ProjectBudgetService } from '../../../../services/project-budget.service';

@Component({
  selector: 'app-new-project-budget',
  templateUrl: './new-project-budget.component.html',
  styleUrl: './new-project-budget.component.scss'
})
export class NewProjectBudgetComponent implements OnInit,OnChanges {


  projectBudgetForm!: FormGroup;
  projectId!: number;
  categories: any[] = [];
  subcategories: any = {};


  @Input() projectBudgetId: number | null = null;
  @Output() retrieveData = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _budgetCategoryService: BudgetCategoryService,
    private _projectBudgetService: ProjectBudgetService,
    private toastService: ToastService,
    private _loadingService: LoadingService
  ) {
    this.projectBudgetForm = this.fb.group({
      projectId : [0],
      budgetCategoryId: ['', Validators.required],
      budgetSubcategoryId: ['', Validators.required],
      qty: [1, Validators.min(1)],
      projectedAmount: ['', Validators.min(0)]
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id: number = Number(params.get('id'));
        this.projectId = id;
    });
    this.getCategories();
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes['projectBudgetId'] && this.projectBudgetId) {
        this.getProjectBudgetById(this.projectBudgetId);
      }
  }


  getProjectBudgetById(id:any) {
    this._loadingService.show();

    this._projectBudgetService.getById(id).subscribe({
      next: (response) => {
        this.projectBudgetForm.patchValue({
          projectId: this.projectId,
          budgetCategoryId: response.data.budgetSubcategory.budgetCategory.id,
          budgetSubcategoryId: response.data.budgetSubcategory.id,
          qty: response.data.qty,
          projectedAmount: response.data.projectedAmount
        });
      },
      error: (error) => {
        console.error(error);
        this._loadingService.hide();
      }
      
    })

    this._loadingService.hide();
  }

  getCategories() {
    this._budgetCategoryService.getAll().subscribe({
      next: (data) => {
        // Manejar estructura paginada: data puede ser array directo o {data: [...], totalCount: ...}
        const rawData = data?.data;
        this.categories = Array.isArray(rawData) ? rawData : (rawData?.data || []);
        this.categories.forEach((category: any) => {
          this.subcategories[category.id] = category.budgetSubcategories;
        });
      },
      error: (error) => {
        console.error(error)
      }
    })
  }

  getSubcategories(categoryId: number): any[] {
    return this.subcategories[categoryId] || [];
  }

  getBudgetTypeName(budgetType: string): string {
    switch (budgetType) {
      case 'INCOME':
        return 'Ingresos';
      case 'EXPENSE':
        return 'Gastos';
      default:
        return 'Desconocido';
    }
  }

  onCategoryChange() {
    this.projectBudgetForm.patchValue({
      budgetSubcategoryId: '',
      projectedAmount: ''
    });
    this.projectBudgetForm.get('budgetSubcategoryId')?.markAsUntouched();
  }

  loadProjectedAmount(data: any) {
      const { value: subcategoryId } = data.target;
      const subcategory = this.findSubcategory(subcategoryId);
      if (subcategory) {
        this.projectBudgetForm.get('projectedAmount')?.setValue(subcategory.amount);
      }
    }
  
    findSubcategory(subcategoryId: number) {
      for (const categoryId in this.subcategories) {
        if (this.subcategories.hasOwnProperty(categoryId)) {
          const subcategories = this.subcategories[categoryId];
          const subcategory = subcategories.find((sub: any) => sub.id == subcategoryId);
          if (subcategory) {
            return subcategory;
          }
        }
      }
      return null;
    }

  onSubmit() {
    this._loadingService.show();
    console.log("before", this.projectBudgetForm.value)

    const newProjectBudget = {
      ...this.projectBudgetForm.value,
      projectId:  Number(this.projectId),
      budgetCategoryId: Number(this.projectBudgetForm.value.budgetCategoryId),
      budgetSubcategoryId: Number(this.projectBudgetForm.value.budgetSubcategoryId),
      qty: Number(this.projectBudgetForm.value.qty),
      projectedAmount: Number(this.projectBudgetForm.value.projectedAmount)      
    };

    if(this.projectBudgetId){
      this._projectBudgetService.update(this.projectBudgetId,newProjectBudget).subscribe({
        next: (response: any) => {
          this.handleSuccess('Presupuesto actualizado correctamente.');
        },
        error: (err) => {
          this.handleError('No se pudo actualizar el Presupuesto.');
        }
      })
    }else{
      this._projectBudgetService.insert(newProjectBudget).subscribe({
        next: (response: any) => {
          this.handleSuccess('Presupuesto creado correctamente.');
        },
        error: (err) => {
          this.handleError('No se pudo crear el Presupuesto.');
        }
      })
    }
    
    console.log("after", this.projectBudgetForm.value)
  }


  private handleSuccess(message: string): void {
    this._loadingService.hide();
    this.toastService.showToast('success', message);
    this.closeModal.emit();
    setTimeout(()=> window.location.reload(), 500)
  }

  private handleError(message: string): void {
    this._loadingService.hide();
    this.toastService.showToast('error', message);
  }

}
